import { Box, Option } from "@mui/joy";
import DarkTypography from "../../common/DarkTypography";
import DarkSelect from "../../common/DarkSelect";
import { GROUP_FILTER_ALL, GROUP_UNGROUPED } from "./groupUtils";

type Props = {
  value: string;
  onChange: (value: string) => void;
  options: string[];
};

export default function GroupFilter({ value, onChange, options }: Props) {
  return (
    <Box sx={{ flex: { sm: "0 1 240px" }, maxWidth: { xs: "95vw", sm: 260 }, minWidth: 0 }}>
      <DarkTypography level="body-sm" colorVariant="primary" sx={{ mb: 0.5 }}>
        Catégories
      </DarkTypography>
      <DarkSelect
        size="sm"
        value={value}
        onChange={(_, v) => onChange((v ?? GROUP_FILTER_ALL) as string)}
        aria-label="Filtrer par catégorie"
        sx={{ width: "100%" }}
      >
        <Option value={GROUP_FILTER_ALL}>Toutes les catégories</Option>
        {options.map((g) => (
          <Option key={g} value={g}>
            {g}
          </Option>
        ))}
        <Option value={GROUP_UNGROUPED}>Sans catégorie</Option>
      </DarkSelect>
    </Box>
  );
}
